import { useEffect, useRef, useState } from "react";
import "./../products/product.css";
import DownArrow from "../../assets/filterArrowDown.svg";
import UpArrow from "../../assets/filterArrowUp.svg";
import { useDispatch } from "react-redux";
import DivisionData from "./divisionData";
import { divisionList } from "../../redux/actions/divisionAction";
import LoadingSpinnerTable from "../../components/utilites/loader";
import NumberPagination from "../../components/Pagination/number-pagination";
import { useNavigate } from "react-router-dom";

const DivisionTable = ({ search, status, page_no }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const componentRef = useRef(null);
  const divisionRef = useRef(null);
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [divisionListdata, setDivisionListdata] = useState("");
  const [openStatus, setOpenStatus] = useState(false);
  const [openDivName, setOpenDivName] = useState(false);
  const [list, setList] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    fetchdivisionList();
  }, [search, status, list, page]);

  const fetchdivisionList = () => {
    setLoading(true);
    dispatch(
      divisionList(
        {
          search,
          status:
            status === "active" ? true : status === "inactive" ? false : null,
          page,
          order_name: list,
        },
        onDivisionSuccess,
        onDivisionError
      )
    );
  };

  const onDivisionSuccess = (data) => {
    setLoading(false);
    setDivisionListdata(data.data.data);
  };

  const onDivisionError = (err) => {
    setLoading(false);
  };

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setOpenStatus(false);
    }
  };

  const handleClickDivisionOutside = (event) => {
    if (divisionRef.current && !divisionRef.current.contains(event.target)) {
      setOpenDivName(false);
    }
  };

  useEffect(() => {
    if (openStatus) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openStatus]);

  useEffect(() => {
    if (openDivName) {
      document.addEventListener("click", handleClickDivisionOutside);
    } else {
      document.removeEventListener("click", handleClickDivisionOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickDivisionOutside);
    };
  }, [openDivName]);

  return (
    <>
      <div>
        <div className="table-container text-nowrap">
          <table className="main-table" style={{ position: "relative" }}>
            <thead>
              <tr className="table-rows">
                <th className="table-heads " width={"6%"}>
                  SL. No
                </th>
                <th className="table-heads" width={"10%"}>
                  Division ID
                </th>
                <th
                  ref={divisionRef}
                  className="table-heads text-nowrap"
                  width={"13%"}
                >
                  <span
                    onClick={() => setOpenDivName(!openDivName)}
                    className={
                      openDivName
                        ? "Medium_Purple cursor_pointer"
                        : "cursor_pointer"
                    }
                  >
                    Division Name
                    {openDivName ? (
                      <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                    ) : (
                      <img src={DownArrow} className=" mx-1" alt="v" />
                    )}
                  </span>
                  {openDivName ? (
                    <div className=" position-relative">
                      <div className="position-absolute status-container d-flex gap-3 px-3">
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="divName"
                            name="divName"
                            value={true}
                            checked={list}
                            onClick={(e) => {
                              setOpenDivName(!openDivName);
                              setList(e.target.value);
                            }}
                          />
                          <span
                            for="divName"
                            className={
                              list === "true" ? "color_747f9e fw_600" : ""
                            }
                          >
                            A-Z
                          </span>
                        </div>
                        <button
                          className="filter-btn px-2 py-0 my-2 fs_12"
                          style={{ height: "28px" }}
                          onClick={() => {
                            setList(false);
                            setOpenDivName(!openDivName);
                          }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : null}
                </th>
                <th className="table-heads" width={"10%"}>
                  Offer Type
                </th>
                <th className="table-heads" width={"15%"}>
                  Reimbursement
                </th>
                <th className="table-heads" width={"12%"}>
                  Order Limit
                </th>
                <th className="table-heads" width={"10%"}>
                  Approval Level
                </th>
                <th
                  ref={componentRef}
                  className="table-heads text-nowrap"
                  width={"8%"}
                >
                  <span
                    onClick={() => setOpenStatus(!openStatus)}
                    className={
                      openStatus
                        ? "Medium_Purple cursor_pointer"
                        : "cursor_pointer"
                    }
                  >
                    {" "}
                    <span className={status ? "Medium_Purple fw_700" : ""}>
                      Status
                    </span>
                    {openStatus ? (
                      <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                    ) : (
                      <img src={DownArrow} className=" mx-1" alt="v" />
                    )}
                  </span>
                  {openStatus ? (
                    <div className=" position-relative">
                      <div className="position-absolute status-container d-flex gap-3 px-3">
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="active"
                            name="area_covered"
                            value={"active"}
                            checked={status === "active"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              navigate(
                                `/division?page=1${
                                  search ? `&search=${search}` : ""
                                }&status=active`
                              );
                            }}
                          />
                          <label
                            htmlFor="active"
                            className={
                              status === "active"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Active
                          </label>
                        </div>
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="inactive"
                            name="area_covered"
                            value={"inactive"}
                            checked={status === "inactive"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              navigate(
                                `/division?page=1${
                                  search ? `&search=${search}` : ""
                                }&status=inactive`
                              );
                            }}
                          />
                          <label
                            htmlFor="inactive"
                            className={
                              status === "inactive"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Inactive
                          </label>
                        </div>
                        <button
                          className="filter-btn px-2 py-0 my-2 fs_12"
                          style={{ height: "28px" }}
                          onClick={() => {
                            setOpenStatus(!openStatus);
                            navigate(
                              `/division?page=1${
                                search ? `&search=${search}` : ""
                              }`
                            );
                          }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : null}
                </th>
                <th className="table-heads-action" width={"25%"}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody style={{ position: "relative" }}>
              {loading === true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : divisionListdata?.vendorDivision?.length > 0 ? (
                <>
                  {divisionListdata?.vendorDivision?.map((eachRow, index) => (
                    <DivisionData
                      key={eachRow?.id}
                      data={eachRow}
                      index={index + 1}
                      fetchdivisionList={fetchdivisionList}
                      currentPage={divisionListdata?.pagination?.currentPage}
                    />
                  ))}
                </>
              ) : (
                <>
                  <tr>
                    <td
                      colSpan="1"
                      className="text-center no-data-container fs_16"
                    >
                      <span>~ No Data Found ~</span>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
        <div className={loading === true ? `loading-event` : ""}>
          {divisionListdata?.pagination?.totalPages > 0 && (
            <NumberPagination
              setCurrentPage={setPage}
              pagination={divisionListdata?.pagination?.currentPage}
              totalPages={divisionListdata?.pagination?.totalPages}
              path={"/division"}
              filters={`${queryString}`}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default DivisionTable;
